import './wdyr';

import FpSdk from 'forepaas/sdk';
import React from 'react';
import { Provider } from 'react-redux'
import LocalActions from 'forepaas/store/local/action';
import QueryStringAction from 'forepaas/store/querystring/action';
import SessionActions from 'forepaas/store/session/action';
import { render } from 'react-dom';
import components from 'src/components';
import App from './App.jsx';

// Prime React
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/tailwind-light/theme.css';

import 'font-awesome/less/font-awesome.less';
import 'react-toastify/dist/ReactToastify.min.css';
import 'src/helpers';
import 'src/styles/styles.less';

import './styles/index.less';

// Import css files

// for date fns
import { setDefaultOptions } from 'date-fns/esm';
import { ja as dateLocaleJa } from 'date-fns/locale';

import ja from '@/helpers/primereactLocales/ja';
import { addLocale, locale } from 'primereact/api';
addLocale('ja', ja);
locale('ja');

setDefaultOptions({ locale: dateLocaleJa });

FpSdk.start()
  .then(() => {
    components.init();

    FpSdk.modules.store.dispatch(LocalActions.initAll())
    FpSdk.modules.store.dispatch(SessionActions.initAll())
    FpSdk.modules.store.dispatch(QueryStringAction.initAll())
  })
  .then(() => {
    render(<Provider store={FpSdk.modules.store}><App /></Provider>, document.getElementById('root'));
  });